import { View } from "@react-pdf/renderer";
import { SideTableRow } from "./SideTableRow";
import { CellTextBoxDot, styles } from "../reportingHelpers";
import React from "react";

export const SideTableLeft = ({
  team,
  intl,
  reboundsTotalInGame,
  offensiveReboundsPercentage,
  defensiveReboundsPercentage,
}) => {
  const defaults = [
    {
      pointsFromTurnover: 0,
      pointsInThePaint: 0,
      pointsSecondChance: 0,
      timesScoreLevel: 0,
      pointsFastBreak: 0,
      pointsFromBench: 0,
    },
  ];
  const teamStats = team.teamStatsPeriods ?? defaults;

  const totalsTurnovers = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.turnovers,
    0
  );
  const totalsAssists = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.assists,
    0
  );
  const totalsSteals = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.steals,
    0
  );
  const totalsFoulsTotal = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.foulsTotal,
    0
  );
  const totalsFoulsDrawn = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.foulsDrawn,
    0
  );
  const pointsInThePaint = teamStats.reduce(
    (acc, stats) => acc + stats.pointsInThePaint,
    0
  );
  const pointsFastBreak = teamStats.reduce(
    (acc, stats) => acc + stats.pointsFastBreak,
    0
  );
  const pointsSecondChance = teamStats.reduce(
    (acc, stats) => acc + stats.pointsSecondChance,
    0
  );
  const rebounds = teamStats.reduce(
    (acc, stats) => acc + stats.totals?.rebounds,
    0
  );

  return (
    <View
      style={{ flexDirection: "column", width: "65mm", borderColor: "white" }}
    >
      <View
        style={{
          ...styles.tableRowFrench,
          borderTopWidth: 1,
          height: "4mm",
          width: "65mm",
          borderColor: "white",
        }}
      >
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.ratio",
            defaultMessage: "Ratio",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.as",
            defaultMessage: "AS",
          })}
          /
          {intl.formatMessage({
            id: "reports.boxscore.table.to",
            defaultMessage: "TO",
          })}
          {/*Assist/Turnovers*/}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.st",
            defaultMessage: "ST",
          })}
          /
          {intl.formatMessage({
            id: "reports.boxscore.table.to",
            defaultMessage: "TO",
          })}
          {/*Steals/Turnovers*/}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.foulsf",
            defaultMessage: "F",
          })}
          /
          {intl.formatMessage({
            id: "reports.boxscore.table.foulsreceived",
            defaultMessage: "For",
          })}
          {/*Foul/Foul Received*/}
        </CellTextBoxDot>
      </View>
      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "65mm",
          borderColor: "white",
        }}
      >
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {""}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {totalsTurnovers ? (totalsAssists / totalsTurnovers).toFixed(2) : "."}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {totalsTurnovers ? (totalsSteals / totalsTurnovers).toFixed(2) : "."}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "25%", height: "4mm", borderColor: "white" }}
        >
          {totalsFoulsDrawn
            ? (totalsFoulsTotal / totalsFoulsDrawn).toFixed(2)
            : "."}
        </CellTextBoxDot>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          borderColor: "white",
        }}
      />

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "65mm",
          borderColor: "white",
        }}
      >
        <CellTextBoxDot
          style={{
            width: "62%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
            borderColor: "white",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundsorpercent",
            defaultMessage: "% Offensive Rebounds",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "38%", height: "4mm", borderColor: "white" }}
        >
          {/* off1/(off1+def2) */}
          {offensiveReboundsPercentage
            ? offensiveReboundsPercentage.toFixed(0) + "%"
            : "."}
        </CellTextBoxDot>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "65mm",
          borderColor: "white",
        }}
      >
        <CellTextBoxDot
          style={{
            width: "62%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
            borderColor: "white",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundsdrpercent",
            defaultMessage: "% Defensive Rebounds",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "38%", height: "4mm", borderColor: "white" }}
        >
          {/* def1/(def1+off2) */}
          {defensiveReboundsPercentage
            ? defensiveReboundsPercentage.toFixed(0) + "%"
            : "."}
        </CellTextBoxDot>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          height: "4mm",
          width: "65mm",
          borderColor: "white",
        }}
      >
        <CellTextBoxDot
          style={{
            width: "62%",
            height: "4mm",
            textAlign: "left",
            paddingLeft: 2,
            borderColor: "white",
          }}
        >
          {intl.formatMessage({
            id: "reports.boxscore.table.reboundstotalpercent",
            defaultMessage: "% Total Rebounds",
          })}
        </CellTextBoxDot>
        <CellTextBoxDot
          style={{ width: "38%", height: "4mm", borderColor: "white" }}
        >
          {reboundsTotalInGame
            ? ((100 * rebounds) / reboundsTotalInGame).toFixed(0) + "%"
            : "."}
        </CellTextBoxDot>
      </View>

      <View
        style={{
          ...styles.tableRowFrench,
          border: "none",
          height: "4mm",
          borderColor: "white",
        }}
      />

      <SideTableRow
        labelText={intl.formatMessage({
          id: "reports.boxscore.pointsinpaint",
          defaultMessage: "Points in the Paint",
        })}
        teamText={pointsInThePaint}
      />
      <SideTableRow
        labelText={intl.formatMessage({
          id: "reports.boxscore.pointsfastbreak",
          defaultMessage: "Fast Break Points",
        })}
        teamText={pointsFastBreak}
      />
      <SideTableRow
        labelText={intl.formatMessage({
          id: "reports.boxscore.pointssecondchance",
          defaultMessage: "Second Chance Points",
        })}
        teamText={pointsSecondChance}
      />
    </View>
  );
};
